export default __webpack_public_path__ + "static/media/SHORTEE.edccea3b.webp";